import { ConsultarResultadoAvaliacaoInstitucionalComponent } from './avaliagov/resultado_avaliacao/resultado-avaliacao-institucional/consultar-resultado-avaliacao-institucional/consultar-resultado-avaliacao-institucional.component';
import { Routes } from '@angular/router';
import { TipoAvaliacaoEnum } from './shared/enums/tipo-avaliacao.enum';
import { TransacoesEnum } from './shared/enums/transacoes.enum';
import { environment } from 'src/environments/environment';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'home',
		pathMatch: 'full'
	},
	{
		path: 'home',
		loadChildren: () => import('./home/home.routes').then(m => m.home_routes),
		data: {
			title: 'Sigepe AvaliaGov',
			breadcrumb: 'Sigepe AvaliaGov',
			showInMenu: false,
			transactions: [
				TransacoesEnum.MANTER_CAD,
				TransacoesEnum.DASH_BOARD_GESTOR,
				TransacoesEnum.DASH_ESTAGIO_PROBATORIO_OPERACIONAL,
				TransacoesEnum.AD_EP_ANALISE_RECURSO,
				TransacoesEnum.MONITORACAO_RESULTADO,
				TransacoesEnum.AVALIACAO_INSTITUCIONAL_GESTOR
			]
		},
		//canLoad: environment.GUARDS_AND_TRANSACTION,
		canActivate: environment.GUARDS_AND_TRANSACTION
	},
	{
		path: 'estagio-probatorio',
		children: [
			{
				path: 'dashboard',
				loadChildren: () => import('./avaliagov/estagio_probatorio/dashboard/routes').then(m => m.estagio_probatorio_routes),
				data: {
					title: 'Consulta Gerencial',
					breadcrumb: 'Consulta Gerencial',
					showInMenu: true,
					transactions: [TransacoesEnum.DASH_ESTAGIO_PROBATORIO_OPERACIONAL]
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			},
			{
				path: 'recursos/gestao',
				loadComponent: () =>
					import('./avaliagov/gestao_recursos/gestao-recursos/gestao-recursos.component').then(m => m.GestaoRecursosComponent),
				data: {
					title: 'Análise de Recursos',
					breadcrumb: 'Análise de Recursos',
					showInMenu: true,
					transactions: [TransacoesEnum.AD_EP_ANALISE_RECURSO] //Trocar
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			},
			{
				path: 'recursos/detalhar/:idRecurso',
				loadComponent: () =>
					import('./avaliagov/gestao_recursos/detalhar-recurso-servidor/detalhar-recurso-servidor.component').then(
						m => m.DetalharRecursoServidorComponent
					),
				data: {
					title: 'Detalhar Recurso',
					breadcrumb: 'Detalhar Recurso',
					showInMenu: false,
					transactions: [TransacoesEnum.AD_EP_ANALISE_RECURSO] //Trocar
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			}
		],
		data: {
			title: 'Estágio Probatório',
			breadcrumb: 'Estágio Probatório',
			showInMenu: true,
			transactions: [TransacoesEnum.DASH_ESTAGIO_PROBATORIO_OPERACIONAL, TransacoesEnum.AD_EP_ANALISE_RECURSO]
		},
		//canLoad: environment.GUARDS_AND_TRANSACTION,
		canActivate: environment.GUARDS_AND_TRANSACTION
	},
	{
		path: 'avaliacao-desempenho',
		children: [
			{
				path: 'dashboard-gestor',
				loadChildren: () => import('./avaliagov/dashboard/dashboard-gestor.routes').then(m => m.dashboard_gestor_routes),
				data: {
					title: 'Consulta Gerencial',
					breadcrumb: 'Consulta Gerencial',
					showInMenu: true,
					transactions: [TransacoesEnum.DASH_BOARD_GESTOR]
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			},
			{
				path: 'resultado-avaliacao-institucional',
				component: ConsultarResultadoAvaliacaoInstitucionalComponent,
				data: {
					title: 'Avaliação Institucional',
					breadcrumb: 'Avaliação Institucional',
					showInMenu: true,
					transactions: [TransacoesEnum.AVALIACAO_INSTITUCIONAL_GESTOR]
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			},
			{
				path: 'monitor-resultado',
				loadComponent: () =>
					import(
						'./avaliagov/resultado_avaliacao/monitor-resultado-individual/monitor_resultado/monitor_resultado.component'
					).then(m => m.MonitorResultadoComponent),
				data: {
					title: 'Monitoramento de Resultado',
					breadcrumb: 'Monitoramento de Resultado',
					showInMenu: true,
					transactions: [TransacoesEnum.MONITORACAO_RESULTADO]
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			},
			{
				path: 'detalhar-resultado-avaliacao/:idAvaliacao',
				loadComponent: () =>
					import(
						'./avaliagov/resultado_avaliacao/detalhar-resultado-avaliacao-individual/detalhar-resultado-avaliacao/detalhar-resultado-avaliacao.component'
					).then(m => m.DetalharResultadoAvaliacaoComponent),
				data: {
					title: 'Detalhamento do Resultado',
					breadcrumb: 'Detalhamento do Resultado',
					showInMenu: false,
					transactions: [TransacoesEnum.MONITORACAO_RESULTADO]
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			},
			{
				path: 'alterar-resultado-avaliacao/:idAvaliacao',
				loadComponent: () =>
					import(
						'./avaliagov/resultado_avaliacao/alterar-resultado-avaliacao-individual/alterar-resultado-avaliacao-individual.component'
					).then(m => m.AlterarResultadoAvaliacaoIndividualComponent),
				data: {
					title: 'Alterar Resultado da Avaliação',
					breadcrumb: 'Alterar Resultado da Avaliação',
					showInMenu: false,
					transactions: [TransacoesEnum.MONITORACAO_RESULTADO],
					tipoAvaliacao: TipoAvaliacaoEnum.AVALIACAO_DESEMPENHO,
					justificativaMaxima: 200,
					justificativaMinima: 3
				},
				//canLoad: environment.GUARDS_AND_TRANSACTION,
				canActivate: environment.GUARDS_AND_TRANSACTION
			}
		],
		data: {
			title: 'Avaliação de Desempenho',
			breadcrumb: 'Avaliação de Desempenho',
			showInMenu: true,
			transactions: [
				TransacoesEnum.DASH_BOARD_GESTOR,
				TransacoesEnum.MONITORACAO_RESULTADO,
				TransacoesEnum.AVALIACAO_INSTITUCIONAL_GESTOR
			]
		},
		//canLoad: environment.GUARDS_AND_TRANSACTION,
		canActivate: environment.GUARDS_AND_TRANSACTION
	},
	{
		path: 'cad',
		loadChildren: () => import('./avaliagov/cad/routes').then(m => m.cad_routes),
		data: {
			title: 'Cadastro CAD',
			breadcrumb: 'Cadastro CAD',
			showInMenu: true,
			transactions: [TransacoesEnum.AD_EP_CAD_COMMON]
		},
		//canLoad: environment.GUARDS_AND_TRANSACTION,
		canActivate: environment.GUARDS_AND_TRANSACTION
	}
];
